import * as $ from "jquery";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  CommonModule,
  LocationStrategy,
  HashLocationStrategy,
  registerLocaleData,
} from "@angular/common";
import localeEs from "@angular/common/locales/es";
import { AngularCropperjsModule } from "angular-cropperjs";
import {
  NgModule,
  LOCALE_ID,
  CUSTOM_ELEMENTS_SCHEMA,
  Injector,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  HttpClientModule,
  HttpClient,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { FullComponent } from "./layouts/full/full.component";
import { BlankComponent } from "./layouts/blank/blank.component";
import { NavigationComponent } from "./shared/header-navigation/navigation.component";
import { SidebarComponent } from "./shared/sidebar/sidebar.component";
import { BreadcrumbComponent } from "./shared/breadcrumb/breadcrumb.component";
import { ModalConfirmComponent } from "./shared/modalconfirm/modalconfirm.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { PERFECT_SCROLLBAR_CONFIG } from "ngx-perfect-scrollbar";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SpinnerComponent } from "./shared/spinner.component";
import { JwtInterceptor } from "./helpers/jwt.interceptor";
import { ErrorInterceptor } from "./helpers/error.interceptor";
import { AgmCoreModule } from "@agm/core";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { NgxSpinnerModule } from "ngx-spinner";
import { FileSaverModule } from "ngx-filesaver";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { DndDirective } from "./directive/dnd.directive";
import { ConfirmaInvitacionComponent } from "./confirma-invitacion/confirma-invitacion.component";
import { PlanReviewComponent } from "./v2/planes-reviews/plan-review/plan-review.component";

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true,
};

registerLocaleData(localeEs, "es");

export let InjectorInstance: Injector;

@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    FullComponent,
    BlankComponent,
    NavigationComponent,
    BreadcrumbComponent,
    ModalConfirmComponent,
    SidebarComponent,
    ConfirmaInvitacionComponent,
    DndDirective,
    PlanReviewComponent,
  ],

  entryComponents: [PlanReviewComponent],

  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    NgMultiSelectDropDownModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule.forRoot(),
    PerfectScrollbarModule,
    NgxSpinnerModule,
    AppRoutingModule,
    CKEditorModule,
    NgxQRCodeModule,
    FileSaverModule,
    NgxUiLoaderModule,
    AngularCropperjsModule,
    BsDatepickerModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyDawPFMR9HMhNCLnrgkYmhaUiB3NvvcBFE",
      libraries: ["places"],
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [TranslateModule],
  providers: [
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: "es" },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private injector: Injector) {
    InjectorInstance = this.injector;
  }
}
